module.exports = __webpack_public_path__ + "static/media/window-close.89de1744.svg";